import React, { useEffect, useState, useMemo } from "react";
import styled from "styled-components";
import {
  ButtonFilled,
  ButtonOutlined,
  Buttontransparent,
  ButtonWhite,
} from "../../../../Reusablecomponents/UIButtons";
import { useNavigate, useLocation } from "react-router-dom";
import { ReactComponent as Alert } from "../../../../assets/images/alert1.svg";
import ReusablePagination from "../../../../Reusablecomponents/ReusablePagination";
import {
  CloseOutlined,
  DownOutlined,
  EyeOutlined,
  LeftOutlined,
  UpOutlined,
} from "@ant-design/icons";
import {
  Button,
  Col,
  message,
  Row,
  Tabs,
  Input,
  Tooltip,
  Form,
  Spin,
  Upload,
  Modal,
  InputNumber,
  DatePicker,
  Select,
  Menu,
  Dropdown,
} from "antd";
import { ReactComponent as CopyIcon } from "../../../../assets/images/Vector.svg";
import { ReactComponent as DeleteIcon } from "../../../../assets/images/delete-icon.svg";
import { ReactComponent as EditIcon } from "../../../../assets/images/Editicon.svg";
import { ReactComponent as ChatIcon } from "../../../../assets/images/Chat.svg";
import { StyledTable } from "../../../../Reusablecomponents/UITable/UITable";
import { ReactComponent as DownloadIcon } from "../../../../assets/images/download1.svg";
import GridBuilder from "../../../../UIBuilderEngine/GridBuilder";
import ReusableDrawer from "../../../../Reusablecomponents/ReusableDrawer";
import UIModal from "../../../../Reusablecomponents/UIModal";
import dayjs from "dayjs";
import { CALL_API } from "../../../../Common/api";
import { useSelector } from "react-redux";
import {
  chargetype,
  EventType,
  priorityType,
} from "../../../../Common/constant";
import moment from "moment";
import ChatComponent from "../../../../Reusablecomponents/Comment/ChatComponent";
import FilesTable from "../../../../Reusablecomponents/FilesTable";
import MapComponent from "../../../../Reusablecomponents/MapComponent";
import LocationPicker from "../../../../Reusablecomponents/LocationPicker/LocationPicker";
import { ReactComponent as MapIcon } from "../../../../assets/images/Group 1000004561.svg";

const WrapperBox = styled.div`
  .customizable_containerthree {
    margin-top: 15px;
  }
  label {
    color: #5f6d8c;
  }
  .customisable_container {
    font-size: 11px;
    white-space: normal;
    word-break: break-word;
    overflow-wrap: break-word;
    line-height: 1.4;
  }
  .div_container {
    background-color: #f8f8f8;
    padding: 7px 7px 7px 7px;
    border-radius: 12px;
    margin-bottom: 10px;
  }
  .containerfour {
    display: flex;
    justify-content: space-between;
    width: 100%;
  }
  .consingment_container {
    display: flex;
    width: 100%;
    justify-content: space-between;
  }
  @media (min-width: 320px) and (max-width: 480px) {
    .consingment_container {
      display: flex;
      flex-direction: column;
    }
    .consingment_container_two {
      display: flex;
      gap: 10px;
    }
    .consingment_container_formbresponsive {
      display: flex;
      flex-direction: row;
      gap: 20px;
      justify-content: end;
    }
    .container_for_consignorpage {
      .consignor_code {
        width: 100% !important;
      }
    }
  }
  @media (min-width: 481px) and (max-width: 768px) {
    .container_for_consignorpage {
      .consignor_code {
        width: 50% !important;
      }
    }
  }
  @media (min-width: 769px) and (max-width: 991px) {
    .container_for_consignorpage {
      .consignor_code {
        width: 33% !important;
      }
    }
  }

  @media (max-width: 320px) {
    .tabsectionfor_table {
      display: flex;
      flex-direction: column;
    }
  }

  .consingment_container_two {
    display: flex;
    align-items: center;
  }
  .consingment_container_record {
    display: flex;
    flex-direction: column;
    gap: 19px;
    text-align: justify;
  }
  p {
    margin-bottom: 0px;
    line-height: normal;
    font-size: 16px;
    font-weight: 400;
  }
  .Create_btn {
    border: none;
    outline: none;
    background-color: rgb(235, 247, 237);
    color: white;
    border-radius: 50%;
    padding: 17px 13px 17px 13px;
    font-size: 16px;
  }

  .left_outlined_icon {
    color: rgb(44, 150, 61);
    transform: scale(0.8);
  }
  .Create_btn_edit {
    border-radius: 50%;
    padding: 9px;
    border: 1px solid rgb(231, 231, 237);
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: rgb(235, 247, 237);
  }
  .container_for_consignorpage {
    background-color: rgb(248, 248, 248);
    border-radius: 12px;
    margin: 16px 5px 20px 5px;
    display: flex;
    width: 100%;
    padding: 10px 10px 10px 10px;
    flex-wrap: wrap;
  }
  .consignor_code {
    width: 25%;
    padding: 10px 10px 10px 10px;
    margin: 5px 0px 5px 0px;
  }
  .consignor_code_container {
    width: 100%;
    padding: 10px 10px 10px 10px;
    margin: 5px 0px 5px 0px;
  }
  .consignor_code > label {
    color: rgb(152, 161, 181);
    padding: 5px 0px 5px 0px;
    font-size: 14px;
    display: block;
    margin-bottom: 4px;
  }
  .Add_btn {
    border: none;
  }
  .tabsectionfor_table {
    display: flex;
    justify-content: space-between;
  }
  .ant-tabs-tab {
    font-size: 15px !important;
    font-weight: 400 !important;
    color: #5f6d8c !important;
    border-radius: 27px !important;
  }
  .ant-tabs-tab-active .ant-tabs-tab-btn {
    color: #2c963d !important;
  }
  .ant-tabs-tab:hover {
    color: #5f6d8c !important; /* Darker green on hover */
  }
  .ant-table-tbody > tr > td > * {
    margin-left: 12px;
  }

  .consignor_tab_container.ant-tabs-top > .ant-tabs-nav::before {
    border-bottom: unset !important;
  }
  .ant-tabs > .ant-tabs-nav .ant-tabs-nav-list {
    display: flex;
    gap: 15px;
  }
  .Creating_Consignor {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 7px 7px 7px 5px;
    margin-bottom: 19px;
    border-bottom: 1px solid rgb(231 231, 237);
  }

  .resolve_btn:hover {
    background-color: green !important;
    color: white !important;
  }

  .container_for_uimodaltwo {
    background-color: rgb(241, 241, 241);
    padding: 70px 70px 70px 70px;
    border-radius: 13px;
    margin-top: 20px;
  }
  .cancel_btn_forpopup_two {
    background-color: rgb(232, 255, 236);
    color: green;
  }
`;

const ConsignCode = ({
  assignedConsignments,
  setConsignee,
  AddEditFormm,
  handleChange,
  handleSubmitForm,
  handleClose,
  drawyeropen,
  setDrawyeropen,
  formData,
  consignmentDetails,
  activeTab,
  setFormData,
  setDrawerOpen,
  setIsEdit,
  handleDelete,
  getAssignedConsignments,
  customFields,
  AllCustomeData,
  reftab,
  CustomeDataUpdate,
  // consignmentDetails
}) => {
  const [form] = Form.useForm();
  const userInfo = useSelector((state) => state?.authTracking?.userInfo);
  const userList = useSelector((state) => state?.authTracking?.userList);
  const consignerList = useSelector(
    (state) => state?.authTracking?.consignerList,
  );
  const transporterList = useSelector(
    (state) => state?.authTracking?.transporterList,
  );
  const consigneeList = useSelector(
    (state) => state?.authTracking?.consigneeList,
  );
  const navigate = useNavigate();
  const location = useLocation();
  const [activekey, setactivekey] = useState("1");
  const [hoveredrow, setHoveredrow] = useState(null);
  const [showModal, SetshowModal] = useState(false);
  const [modalType, setModalType] = useState(null);
  const [isDeleteModalVisible, setIsDeleteModalVisible] = useState(false);
  const [deleteId, setDeleteId] = useState(null); // To store the ID of the consignment to delete
  const handleFileUpload = async (payload) => {
    setLoading(true);
    const { data } = await CALL_API("POST", "common/file/addFile", payload);
    setLoading(false);
    getFileData();
  };
  const [total, setTotal] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);

  // Open handlers for both modals
  const handleresolveopen = () => setModalType("resolve");
  const handleudoUpdateOpen = () => setModalType("udoUpdate");
  const [loading, setLoading] = useState(false);
  const [eventList, setEventList] = useState([]);

  const [kpiList, setKpiList] = useState([]);

  const [filesList, setFilesList] = useState([]);

  const [commentsList, setCommentsList] = useState([]);
  const [isConformationModal, setIsConformationModal] = useState(false);
  const [newLoading, setNewLoading] = useState(false);
  const [copyId, setCopyId] = useState(null);
  const [isEventEdit, setIsEventEdit] = useState(false);
  const [isModalOpeN, setIsModalOpeN] = useState(false);
  const [eventData, setEventData] = useState({});
  const evetype = EventType.find((item, index) => {
    return item.value === eventData?.eventType;
  });

  const [isLocationPickerVisible, setIsLocationPickerVisible] = useState(false);
  const [selectedLocation, setSelectedLocation] = useState(null);
  const [popupMessage, setPopupMessage] = useState(null); // To store the message
  const [isPopupVisible, setIsPopupVisible] = useState(false); // To control popup visibility
  const [startEndLoc, setStartEndloc] = useState([]);
  //map icon for event tab
  const [eventLocations, setEventLocations] = useState({});
  const [currentEventKey, setCurrentEventKey] = useState(null); // Set before opening location picker
  const [selectedRecord, setSelectedRecord] = useState(null);
  const [locationList, setLocationList] = useState([]);
  const [eventlocationtab, setEventlocationTab] = useState([]);
  const [mapicon, setMapicon] = useState(false);
  const [isMapModalOpen, setIsMapModalOpen] = useState(false);
  const reduxPermissions = useSelector(
    (state) => state?.authTracking?.myPermissionList || {},
  );
  const hasPermission = (seccode, action) => {
    if (!seccode || !action) return false;
    const code = seccode.toUpperCase();
    const act = action.toUpperCase();
    return (
      Array.isArray(reduxPermissions?.[code]) &&
      reduxPermissions[code].includes(act)
    );
  };

  const updateAllowed = useMemo(
    () => hasPermission("CONSIGN", "UPC"),
    [reduxPermissions],
  );
  const deleteAllowed = useMemo(
    () => hasPermission("CONSIGN", "DC"),
    [reduxPermissions],
  );
  const copyAllowed = useMemo(
    () => hasPermission("CONSIGN", "CYC"),
    [reduxPermissions],
  );
  const evUpdateAllowed = useMemo(
    () => hasPermission("CONSIGN", "CUE"),
    [reduxPermissions],
  );
  const viewEvAllowed = useMemo(
    () => hasPermission("CONSIGN", "VE"),
    [reduxPermissions],
  );
  const fileUpAllowed = useMemo(
    () => hasPermission("CONSIGN", "UF"),
    [reduxPermissions],
  );
  const handleClosecontainer = () => {
    setIsMapModalOpen(false);
  };

  const handleLocationSelect = (location) => {
    setSelectedLocation({
      location: location?.place_name,
      lat: location?.center?.[1],
      lng: location?.center?.[0],
      Lat: location?.center?.[1],
      Lng: location?.center?.[0],
    });
    setEventData((prev) => ({
      ...prev,
      lat: location?.center?.[1],
      lng: location?.center?.[0],
      Lat: location?.center?.[1],
      Lng: location?.center?.[0],
    }));
    form.setFieldsValue({
      location: location?.place_name,
      lat: location?.center?.[1],
      lang: location?.center?.[0],
    }); // Update the form field
    setIsLocationPickerVisible(false); // Close the LocationPicker modal
  };
  const handleSubmit = async (values) => {
    setLoading(true);
  };

  // Common close handler
  const handleModalClose = () => setModalType(null);

  const handleCopyClick = async () => {
    setNewLoading(true);

    try {
      const { data, ResponseCode } = await CALL_API(
        "POST",
        "consignment/copy",
        {
          consignId: copyId,
          McId: userInfo?.MCID,
        },
      );
      if (ResponseCode !== 200) {
        message.error("Something went wrong. Please try again later!");
      } else {
        message.success("Consignment duplicated successfully");
      }
      setIsConformationModal(false);
      setCopyId(null);
      getAssignedConsignments();
      setConsignee(false);
      setNewLoading(false);
    } catch (error) {
      console.error("[getAssignedConsignments] error -->", error);
    }
  };

  const getAllKpiList = async () => {
    try {
      const { data } = await CALL_API(
        "POST",
        "consign/get_all_kpipages_form_consign",
        {
          McId: userInfo?.MCID,
          ConsignId: consignmentDetails?.ConsignId,
        },
      );
      setKpiList(data);
    } catch (error) {
      console.error("[getAssignedConsignments] error -->", error);
    }
  };

  const handlePageChange = (page, pageSize) => {
    setCurrentPage(page);
    setPageSize(pageSize);
  };

  const handlePageSizeChange = (value) => {
    setPageSize(value);
    setCurrentPage(1);
  };

  const getEventsList = async () => {
    try {
      const { data } = await CALL_API("POST", "getConsignEventById", {
        consignId:
          consignmentDetails?.ConsignmentId || consignmentDetails?.ConsignId,
      });
      setEventList(data);
    } catch (error) {
      console.error("[getAssignedConsignments] error -->", error);
    }
  };

  const getSingleConsinment = async () => {
    const { data } = await CALL_API("POST", "getSingleConsignById", {
      consignId: consignmentDetails?.ConsignId,
      MCID: userInfo?.MCID,
    });

    if (data) {
      const { STARTLAT, STARTLNG, ENDLAT, ENDLNG } = data;

      setStartEndloc([
        {
          lat: parseFloat(STARTLAT),
          lng: parseFloat(STARTLNG),
        },
        {
          lat: parseFloat(ENDLAT),
          lng: parseFloat(ENDLNG),
        },
      ]);
    }
  };

  const getsingleHistoryDataForLoc = async (id) => {
    const { data } = await CALL_API(
      "GET",
      `consignment/getDriverLocation?ConsignId=${consignmentDetails?.ConsignId}&EvType=1`,
    );
    setEventlocationTab(data);
  };

  const getAllLocationList = async () => {
    try {
      const { data } = await CALL_API("POST", "getAllLocationByConsignId", {
        consignId: consignmentDetails?.ConsignId,
        evType: activeTab === "label2" ? "2" : "1",
      });
      // setLocationList(data);
      setLocationList(
        data?.map((item) => {
          return { lat: item?.Lat, long: item?.Lng };
        }),
      );
    } catch (error) {
      console.error("[getAssignedConsignments] error -->", error);
    }
  };

  const [CustomData, setCustomData] = useState([]);

  const getcustomedatabyRefId = async () => {
    try {
      // const { data } = await CALL_API(
      //   "GET",
      //   `mastertable/GetCustomeData?RefId=${fuelId}`
      // );
      const refId = consignmentDetails?.ConsignId;
      const mcId = userInfo?.MCID;

      const [consignResp, bulkCreateResp] = await Promise.all([
        CALL_API("POST", `mastertable/GetByReftab`, {
          ReftableId: "Consign",
          RefId: refId,
          Active: 1,
          McId: mcId,
        }),
        CALL_API("POST", `mastertable/GetByReftab`, {
          ReftableId: "BulkCreate",
          RefId: refId,
          Active: 1,
          McId: mcId,
        }),
      ]);

      const normalize = (d) => {
        if (Array.isArray(d)) return d;
        if (typeof d === "object" && d !== null) return [d];
        return [];
      };

      // Merge both reftabs so details page doesn't depend on opening forms.
      const merged = [
        ...normalize(consignResp?.data),
        ...normalize(bulkCreateResp?.data),
      ];

      // De-duplicate: same field can exist in both reftabs.
      // Prefer a non-empty VALUE; otherwise keep the first seen.
      const byCfid = new Map();
      for (const item of merged) {
        const key = String(item?.FIELDNAME ?? "");
        if (!key) continue;
        const prev = byCfid.get(key);
        const nextVal = item?.VALUE;
        const prevVal = prev?.VALUE;
        const nextHasVal = nextVal !== undefined && nextVal !== null && String(nextVal).trim() !== "";
        const prevHasVal = prevVal !== undefined && prevVal !== null && String(prevVal).trim() !== "";

        if (!prev || (nextHasVal && !prevHasVal)) {
          byCfid.set(key, item);
        }
      }

      setCustomData(Array.from(byCfid.values()));
    } catch (error) {
      console.error("Error fetching custom data:", error);
      setCustomData([]);
    }
  };

  const getFileData = async () => {
    setLoading(true);
    const { data } = await CALL_API("POST", `trip/getFileTab`, {
      refTab: "consign",
      refId: consignmentDetails?.ConsignId,
    });
    setFilesList(data);
    setLoading(false);
  };

  const getCommentData = async () => {
    setLoading(true);
    const { data } = await CALL_API("POST", `trip/getcommentTab`, {
      refTab: "consign",
      refId: consignmentDetails?.ConsignId,
    });
    setCommentsList(data);
    setLoading(false);
  };
  // useEffect(() => {

  // },[])
  useEffect(() => {
    if (activekey === "1") {
      getEventsList();
      getcustomedatabyRefId();
    } else if (activekey === "2") {
      getFileData();
    } else if (activekey === "3") {
      getCommentData();
    } else if (activekey === "4") {
      getAllLocationList();
      getsingleHistoryDataForLoc();
      getSingleConsinment();
    } else if (activekey === "5") {
      getAllKpiList();
    }
  }, [activekey]);
  useEffect(() => {
    getAssignedConsignments();
  }, [AllCustomeData]);
  useEffect(() => {
    getEventsList();
  }, []);
  const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

  const updateevents = async (values = {}) => {
    setLoading(true);
    const { location, datetime, odo, remarks } = values;
    let modOnDate;
    if (datetime && typeof datetime.toDate === "function") {
      // If it's a dayjs object
      modOnDate = datetime.toDate();
    } else if (datetime instanceof Date) {
      // Already a Date object
      modOnDate = datetime;
    } else {
      // Fallback to current
      modOnDate = new Date();
    }
    const { data } = await CALL_API("POST", "consign/webeventedit", {
      consignId:
        consignmentDetails?.ConsignId || consignmentDetails?.ConsignmentId, // Consignment ID to update
      evType: eventData?.EVTYPE, // Event Type (e.g., 1 for Started, 6 for Finished)
      odoKms: Number(odo), // Odometer reading
      remarks: remarks || "", // Optional remarks
      lat: eventData?.Lat, // Latitude (optional)
      lng: eventData?.Lng, // Longitude (optional)
      // modOn: datetime ? datetime.toISOString() : new Date().toISOString(),
      modOn: modOnDate.toISOString(),
      modBy: userInfo?.UID,
      evid: eventData?.EVID,
    });

    setIsModalOpeN(false);

    let eventupdate = "Event updated sucessfully";

    if (
      data?.message ===
      "ODOEND  must be greater than ODOSTART . No updates performed."
    ) {
      message.error(data?.message);
    } else if (data?.message) {
      // Show the popup with the backend message
      setPopupMessage(data?.message);
      setIsPopupVisible(true);
    } else {
      message.success(eventupdate);
    }
    // Call getAssignedConsignments after the API call
    if (typeof getAssignedConsignments === "function") {
      await getAssignedConsignments();
    }

    await delay(500);
    await getEventsList();

    //  Call calculateCarbonFootPrint if event is 'Finished'
    if (eventData?.EVTYPE === 11) {
      try {
        const carbonResp = await CALL_API(
          "GET",
          "consign/calculateCarbonFootPrint",
        );
      } catch (error) {
        console.error("Carbon footprint calculation failed:", error);
      }
    }

    setLoading(false);
  };

  //mapbox location filter functionality
  const gpsEvents = useMemo(() => {
    return eventList.filter((item) => item.Lat && item.Lng);
  }, [eventList]);
  const getLocationName = async (Lat, Lng) => {
    const accessToken =
      "pk.eyJ1Ijoicm9iZXJ0a3BtIiwiYSI6ImNtNml6aWs1dzA0dWwybHM4aGd2NWl2NmgifQ.AOsGlqDkaT6FSAMor3Grow";
    const url = `https://api.mapbox.com/geocoding/v5/mapbox.places/${Lng},${Lat}.json?access_token=${accessToken}`;
    const response = await fetch(url);
    const data = await response.json();
    return data.features[0]?.place_name || "Unknown location";
  };

  const handlemapicon = async (record) => {
    if (record?.Lat && record?.Lng) {
      // Fetch location name from Mapbox
      const locationName = await getLocationName(record.Lat, record.Lng);
      setSelectedRecord({ ...record, locationName });
      setIsMapModalOpen(true);
    } else {
      message.warning("No valid GPS location for this event.");
    }
  };

  const columns1 = [
    {
      title: "Event",
      dataIndex: "EVTYPE",
      key: "EVTYPE",
      render: (text, record) => {
        const eventName = EventType?.find(
          (item) => item.value === record.EVTYPE,
        )?.name;
        const hasGPS = record?.Lat && record?.Lng;

        return (
          <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
            {hasGPS && (
              <MapIcon
                onClick={() => handlemapicon(record)}
                style={{ width: "16px", height: "16px", cursor: "pointer" }}
              />
            )}
            <div>{eventName}</div>
          </div>
        );
      },
    },
    {
      title: "Updated on",
      dataIndex: "MODON",
      key: "MODON",
      render: (text) => {
        if (!text) return "---";
        const formatted = moment(text).isValid()
          ? moment(text).format("Do MMM YYYY; hh:mm A")
          : "---";
        return formatted;
      },
    },
    {
      title: "Updated by",
      dataIndex: "USERNAME",
      key: "USERNAME",
      render: (text) => {
        const users = Array.isArray(userList) ? userList : userList?.data || [];
        return users.find((item) => item?.UID === text)?.FULLNM || text;
      },
    },
    {
      title: "Remarks",
      dataIndex: "REMARKS",
      key: "REMARKS",
      render: (text) => text || "---",
    },
    {
      title: "",
      dataIndex: "",
      key: "",
      width: "10%",
      render: (_, record) => {
        const evtype = record?.EVTYPE;

        // Hide edit icon for Accepted (value 0)
        if (evtype === 0) return null;

        return (
          <div
            className={
              hoveredrow === record.key
                ? "d-flex gap-3 opacity-100"
                : "opacity-1"
            }
          >
            <Tooltip title={!evUpdateAllowed ? "No permission" : ""}>
              <EditIcon
                onClick={() => {
                  if (!evUpdateAllowed) return;
                  setEventData({ ...record, eventType: record?.EVTYPE });
                  setIsEventEdit(true);
                  form.setFieldsValue({
                    location: "",
                    lat: "",
                    lang: "",
                    datetime: record?.MODON ? dayjs(record.MODON) : dayjs(),
                    remarks: record?.REMARKS || "",
                    // odo: consignmentDetails.StartLoc,
                    eventType: record?.EVTYPE,
                  });
                  setIsModalOpeN(true);
                }}
                style={{ cursor: evUpdateAllowed ? "pointer" : "not-allowed" }}
              />
            </Tooltip>
          </div>
        );
      },
    },
  ];

  const getFieldsForEvent = (evtype) => {
    if (evtype === 1 || evtype === 11) {
      return ["odo", "datetime", "location", "remarks"];
    } else if ([2, 3, 4, 5, 6, 7, 8, 9, 10].includes(evtype)) {
      return ["datetime", "location", "remarks"];
    }
    return [];
  };

  const handlemouseenter = (key) => {
    setHoveredrow(key);
  };

  const handlemouseleave = () => {
    setHoveredrow(null);
  };

  const columns5 = [
    {
      title: "KPI Name",
      dataIndex: "NAME",
      key: "NAME",
    },
    {
      title: "Date & Time",
      dataIndex: "RESOLVEDON",
      key: "RESOLVEDON",
    },
    {
      title: "Target Duration",
      dataIndex: "DURATION",
      key: "DURATION",
    },
    {
      title: "Actual Duration",
      dataIndex: "actualduration",
      key: "actualduration",
    },
    {
      title: "Difference",
      dataIndex: "difference",
      key: "difference",
    },
    {
      title: "Resolved by",
      dataIndex: "RESOLVEDBY",
      key: "RESOLVEDBY",
      render: (text, record) => (
        <>
          <div className="consingment_container_record">
            <p>Tony Fernandes</p>
            <i>24th Aug 2024; 07:10 AM</i>
          </div>
        </>
      ),
    },
    {
      title: "Message",
      dataIndex: "MESSAGE",
      key: "MESSAGE",
      width: "20%",
      render: (_, record) => (
        <>
          <div
            className={
              hoveredrow === record.key
                ? "d-flex align-items-center height-[50px]"
                : "opacity-0"
            }
          >
            {record?.Status === "Resolved" ? (
              <ChatIcon />
            ) : hoveredrow === record.key ? (
              <>
                <div className="d-flex align-items-center gap-3">
                  <ChatIcon />
                  <Button onClick={handleresolveopen} className="resolve_btn">
                    Resolve
                  </Button>
                </div>
              </>
            ) : null}
          </div>
        </>
      ),
    },
  ];

  const handlechange = (key) => {
    setactivekey(key);
  };
  const handleClickme = () => {
    if (location.state?.fromTripPage && location.state?.tripId) {
      // Go back to TripCode.js with the tripId
      navigate(`/TripList1`, { state: { from: "consignment", tripId: location.state.tripId, consignmentRecord: location.state.consignmentRecord } });
    } else {
      setConsignee(false);
    }
  };
  const editModuleupdate = () => {
    handleresolveopen(true);
    // updateevents()
  };
  const getpickupDropoff = async (consignorId) => {
    try {
      const { data } = await CALL_API(
        "GET",
        `consign/getpickupDropofflocation?ENTID=${consignorId}&MCID=${userInfo?.MCID}`,
        {},
      );

      const locations = Array.isArray(data?.data) ? data.data : [];
      // setPickupDropoffLocations(data || []);
      setFormData((prev) => ({
        ...prev,
        plocation: data?.[0]?.ADDRESS,
        plocationname: {
          latitude: data?.[0]?.LATITUDE || 0,
          longitude: data?.[0]?.LONGITUDE || 0,
          place_name: data?.[0]?.ADDRESS || 0,
        },
      }));
    } catch (error) {
      console.error("getpickupDropoff error -->", error);
    }
  };

  const handleEdit = () => {
    const newFormData = {
      chargetype: consignmentDetails?.ChargeType,
      consignor: consignerList?.find(
        (item) => item?.Name === consignmentDetails?.CustName,
      )?.ID,
      ddate: dayjs(consignmentDetails?.DropOffDateTime),
      dropoffnotes: consignmentDetails?.DropOffNote,
      dlocation: consignmentDetails?.EndLocation || "",
      gross: consignmentDetails?.GrossVolume,
      GrossWeight: consignmentDetails?.GrossWeight,
      // switch: record?.ISDELOTP,
      pdate: dayjs(consignmentDetails?.PickUpDateTime),
      pickupnotes: consignmentDetails?.PickUpNote,
      priority: consignmentDetails?.Priority,
      transporter: transporterList?.find(
        (item) => item?.Name === consignmentDetails?.SupName,
      )?.ID,
      // transporter: record?.SupName,
      remark: consignmentDetails?.Remarks,
      consignee: consigneeList?.find(
        (item) => item?.Name === consignmentDetails?.RecName,
      )?.ID, // Map consignee to its ID
      plocation: consignmentDetails?.StartLocation || "",
      TripId: consignmentDetails?.TripId,
      CrBy: consignmentDetails?.CrBy,
      ConsignId: consignmentDetails?.ConsignId,
      EndLat: consignmentDetails?.EndLat || 0,
      EndLng: consignmentDetails?.EndLng || 0,
      switch: false,
      StartLat: consignmentDetails?.StartLat || 0,
      StartLng: consignmentDetails?.StartLng || 0,
      // Map transporter to its ID
    };
    if (customFields && customFields.length > 0) {
      customFields.forEach((field) => {
        const cfid = field.CFID;
        // Check if the record has this custom field value
        if (
          consignmentDetails[cfid] !== undefined &&
          consignmentDetails[cfid] !== null
        ) {
          newFormData[cfid] = consignmentDetails[cfid];
        }
      });
    }
    setFormData(newFormData);
    setIsEdit(true);
    setDrawerOpen(true);

    // Always fetch pickup/dropoff for the selected consignor
    getpickupDropoff(newFormData.consignor);
  };

  const user = { UID: userInfo?.UID };

  // Set initial datetime when modal is open and field is visible
  useEffect(() => {
    if (
      isModalOpeN &&
      getFieldsForEvent(eventData?.EVTYPE)?.includes("datetime")
    ) {
      if (!form.getFieldValue("datetime")) {
        form.setFieldsValue({ datetime: dayjs() });
      }
    }
    // eslint-disable-next-line
  }, [isModalOpeN, eventData?.EVTYPE, form]);

  const [dropdownselectchange, setDropdownselectchange] = useState("1");
  const handledropdownchange = (event) => {
    setDropdownselectchange(event.key);
  };
  const menu = (
    <Menu>
      <Menu.Item
        onClick={(e) => {
          handledropdownchange(e);
        }}
        key="1"
      >
        Event
      </Menu.Item>
      <Menu.Item
        onClick={(e) => {
          handledropdownchange(e);
        }}
        key="2"
      >
        Files
      </Menu.Item>
      <Menu.Item
        onClick={(e) => {
          handledropdownchange(e);
        }}
        key="3"
      >
        Comment
      </Menu.Item>
      <Menu.Item
        onClick={(e) => {
          handledropdownchange(e);
        }}
        key="4"
      >
        Location
      </Menu.Item>
      <Menu.Item
        onClick={(e) => {
          handledropdownchange(e);
        }}
        key="5"
      >
        KPIs
      </Menu.Item>
    </Menu>
  );

  return (
    <>
      <UIModal
        width={600}
        open={modalType !== null} // Open if any modal type is set
        onClose={handleModalClose}
        closeButton={false}
        header={
          <WrapperBox>
            <Row>
              <Col xl={24} sm={24}>
                <div className="modal_container_forfiltermenu">
                  <h4 className="flilter_five">
                    {modalType === "resolve"
                      ? "Resolving KPI"
                      : "Updating ODO Reading"}
                  </h4>
                </div>
                <hr />
              </Col>

              {modalType === "resolve" && (
                <Col xl={24} sm={24}>
                  <p>Give the reason or comment to resolve</p>
                </Col>
              )}

              {modalType === "udoUpdate" && (
                <Col xl={24} sm={24}>
                  <p>ODO Reading</p>
                </Col>
              )}

              <Col xl={24} sm={24}>
                <div className="container_for_uimodaltwo"> </div>
              </Col>
            </Row>
          </WrapperBox>
        }
        footer={[
          <WrapperBox key="footer">
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "flex-end",
                gap: "15px",
              }}
            >
              <ButtonFilled
                onClick={handleModalClose}
                className="cancel_btn_forpopup_two"
              >
                Cancel
              </ButtonFilled>
              <ButtonFilled onClick={editModuleupdate}>
                {modalType === "resolve" ? "Resolve" : "Update"}
              </ButtonFilled>
            </div>
          </WrapperBox>,
        ]}
      />
      <WrapperBox>
        <Row gutter={16}>
          <Col xs={24} xl={24}>
            <div className="consingment_container">
              <div className="consingment_container_two">
                <ButtonOutlined onClick={handleClickme} className="Create_btn">
                  <LeftOutlined className="left_outlined_icon" />
                </ButtonOutlined>
                <p>Consign Code - {consignmentDetails?.Code}</p>
              </div>

              <div className="consingment_container_two  consingment_container_formbresponsive">
                <Tooltip title={!copyAllowed ? "No permission" : ""}>
                  <ButtonOutlined className="Create_btn_edit">
                    <CopyIcon
                      style={{
                        cursor: copyAllowed ? "pointer" : "not-allowed",
                      }}
                      onClick={() => {
                        if (!copyAllowed) return;
                        setIsConformationModal(true);
                        setCopyId(consignmentDetails?.ConsignId);
                      }}
                    />
                  </ButtonOutlined>
                </Tooltip>
                <Tooltip title={!updateAllowed ? "No permission" : ""}>
                  <ButtonOutlined className="Create_btn_edit">
                    <EditIcon
                      style={{
                        cursor: updateAllowed ? "pointer" : "not-allowed",
                      }}
                      onClick={() => {
                        if (!updateAllowed) return;
                        handleEdit();
                      }}
                    />
                  </ButtonOutlined>
                </Tooltip>
                <Tooltip title={!deleteAllowed ? "No permission" : ""}>
                  <ButtonOutlined className="Create_btn_edit">
                    <DeleteIcon
                      style={{
                        cursor: deleteAllowed ? "pointer" : "not-allowed",
                      }}
                      onClick={() => {
                        if (!deleteAllowed) return;
                        setDeleteId(consignmentDetails?.ConsignId); // Set the ID of the consignment to delete
                        setIsDeleteModalVisible(true); // Show the delete confirmation modal
                      }}
                    />
                  </ButtonOutlined>
                </Tooltip>
              </div>
            </div>
          </Col>
        </Row>
      </WrapperBox>
      <WrapperBox>
        <Row gutter={16}>
          {window.innerWidth >= 320 && window.innerWidth <= 426 ? (
            <Row className="div_container p-4" gutter={[2, 2]}>
              <Col xs={12} sm={12} md={12} lg={8} className="mb-4  ">
                <label>Consignor</label>
                <p>{consignmentDetails?.CustName}</p>
              </Col>
              <Col xs={12} sm={12} md={12} lg={8} className="mb-4">
                <label>Consignee</label>
                <p>{consignmentDetails?.RecName}</p>
              </Col>
              <Col xs={12} sm={12} md={12} lg={8} className="mb-4">
                <label>Transporter</label>

                <p>
                  {(consignmentDetails?.SupName || "-")
                    .split(",")
                    .map((part, i) => (
                      <span
                        key={i}
                        style={{
                          display: "block",
                          marginBottom: "6px",
                          lineHeight: "20px",
                        }}
                      >
                        {part.trim()}
                        {i <
                          consignmentDetails?.SupName.split(",").length - 1 &&
                          ","}
                      </span>
                    ))}
                </p>
              </Col>
              <Col xs={12} sm={12} md={12} lg={8}>
                {" "}
                <label>Charge Type</label>
                <p>
                  {chargetype?.find(
                    (item) => item?.value === consignmentDetails?.ChargeType,
                  )?.name || "-"}
                </p>
              </Col>
              <Col xs={12} sm={12} md={12} lg={8} className="mb-4">
                <label>Priority</label>
                <p>
                  {priorityType?.find(
                    (val) => val.value === consignmentDetails?.Priority,
                  )?.name || "-"}
                </p>
              </Col>
              <Col xs={12} sm={12} md={12} lg={8} className="mb-4">
                <label>No. of Containers</label>
                <p>---</p>
              </Col>
              <Col xs={12} sm={12} md={12} lg={8} className="mb-4">
                {" "}
                <label>Dimension of single container (in Cm)</label>
                <p className="customisable_container">---</p>
              </Col>
              <Col xs={12} sm={12} md={12} lg={8} className="mb-4">
                {" "}
                <label>Gross Weight (in Kg)</label>
                <p className="customisable_container">
                  {consignmentDetails?.GrossWeight || "---"}
                </p>
              </Col>
              <Col xs={12} sm={12} md={12} lg={8} className="mb-4">
                {" "}
                <label>Delivery Pin</label>
                <p className="customisable_container">
                  {consignmentDetails?.ISDELOTP || "---"}
                </p>
              </Col>
              <Col xs={12} sm={12} md={12} lg={8} className="mb-4">
                {" "}
                <label>Pickup Location</label>
                <p>
                  {(consignmentDetails?.StartLocation || "---")
                    .split(",")
                    .map((part, i) => (
                      <span
                        key={i}
                        style={{
                          display: "block",
                          marginBottom: "6px",
                          lineHeight: "20px",
                        }}
                      >
                        {part.trim()}
                        {i <
                          consignmentDetails?.StartLocation.split(",").length -
                          1 && ","}
                      </span>
                    ))}
                </p>
              </Col>
              <Col xs={12} sm={12} md={12} lg={8} className="mb-4">
                {" "}
                <label>Pickup Date & Time</label>
                <div className="customisable_container">
                  {" "}
                  {consignmentDetails?.PickUpDateTime
                    ? moment(consignmentDetails.PickUpDateTime)
                      .subtract(3, "hours")
                      .format("Do MMM YYYY;  hh:mm A")
                    : "---"}
                </div>
              </Col>
              <Col xs={12} sm={12} md={12} lg={8} className="mb-4">
                <label>Drop off Location</label>

                <p>
                  {(consignmentDetails?.EndLocation || "---")
                    .split(",")
                    .map((part, i) => (
                      <span
                        key={i}
                        style={{
                          display: "block",
                          marginBottom: "6px",
                          lineHeight: "20px",
                        }}
                      >
                        {part.trim()}
                        {i <
                          consignmentDetails?.EndLocation.split("").length -
                          1 && ","}
                      </span>
                    ))}
                </p>
              </Col>
              <Col xs={12} sm={12} md={12} lg={8} className="mb-4">
                {" "}
                <label>Dropoff Date & Time</label>
                <label>Dropoff Date & Time</label>
                <p>
                  {" "}
                  {moment(consignmentDetails?.DropOffDateTime)
                    .format("Do MMM YYYY; hh:mm A")
                    .split(",")
                    .map((part, i) => (
                      <span
                        key={i}
                        style={{
                          display: "block",
                          marginBottom: "6px",
                          lineHeight: "20px",
                        }}
                      >
                        {part.trim()}
                        {i <
                          consignmentDetails?.DropOffDateTime.split(",")
                            .length -
                          1 && ","}
                      </span>
                    )) || "---"}
                </p>
              </Col>
              <Col xs={12} sm={12} md={12} lg={8} className="mb-4">
                {" "}
                <label>Pickup Notes</label>
                <p className="customisable_container">
                  {consignmentDetails?.PickUpNote || "---"}
                </p>
              </Col>
              <Col xs={12} sm={12} md={12} lg={8} className="mb-4">
                {" "}
                <label>Drop off Notes</label>
                <p className="customisable_container">
                  {consignmentDetails?.DropOffNote || "---"}
                </p>
              </Col>
              <Col xs={12} sm={12} md={12} lg={8} className="mb-4">
                {" "}
                <label>Remarks</label>
                <p className="customisable_container">
                  {consignmentDetails?.Remarks || "---"}
                </p>
              </Col>
              <Col xs={12} sm={12} md={12} lg={8} className="mb-4">
                {" "}
                <label>Link Dossier</label>
                <p className="customisable_container">---</p>
              </Col>
              <Col xs={12} sm={12} md={12} lg={8} className="mb-4">
                {/* <label>Order No</label>
                          <p  className="customisable_container">---</p> */}
              </Col>
              <Col xs={12} sm={12} md={12} lg={8} className="mb-4">
                {" "}
                {/* <label>Reference No</label>
                          <p  className="customisable_container">---</p> */}
                <label>Trip</label>
                <p></p>
              </Col>
              <Col xs={12} sm={12} md={12} lg={8} className="mb-4">
                {" "}
                <label>Container No</label>
                <p className="customisable_container">---</p>
              </Col>
              <Col xs={12} sm={12} md={12} lg={8} className="mb-4">
                {" "}
                <label>Container No</label>
                <p className="customisable_container">---</p>
              </Col>
            </Row>
          ) : (
            <Col xs={24} xl={24}>
              <div className="container_for_consignorpage">
                <div className="consignor_code">
                  <label>Consignor</label>
                  <p>{consignmentDetails?.CustName}</p>
                </div>
                <div className="consignor_code">
                  <label>Consignee</label>
                  <p>{consignmentDetails?.RecName}</p>
                </div>
                <div className="consignor_code">
                  <label>Transporter</label>

                  <p>
                    {(consignmentDetails?.SupName || "---")
                      .split(",")
                      .map((part, i) => (
                        <span
                          key={i}
                          style={{
                            display: "block",
                            marginBottom: "6px",
                            lineHeight: "20px",
                          }}
                        >
                          {part.trim()}
                          {i <
                            consignmentDetails?.SupName.split(",").length - 1 &&
                            ","}
                        </span>
                      ))}
                  </p>
                </div>
                <div className="consignor_code">
                  <label>Charge Type</label>
                  <p>
                    {chargetype?.find(
                      (item) => item?.value === consignmentDetails?.ChargeType,
                    )?.name || "---"}
                  </p>
                </div>
                <div className="consignor_code">
                  <label>Priority</label>
                  <p>
                    {priorityType?.find(
                      (val) => val.value === consignmentDetails?.Priority,
                    )?.name || "---"}
                  </p>
                </div>
                <div className="consignor_code">
                  <label>No. of Containers</label>
                  <p>---</p>
                </div>
                <div className="consignor_code">
                  <label>Dimension of single container (in Cm)</label>
                  <p>---</p>
                </div>
                <div className="consignor_code">
                  <label>Gross Weight (in Kg)</label>
                  <p>{consignmentDetails?.GrossWeight || "---"}</p>
                </div>

                <div className="consignor_code_container consignor_code">
                  <label>Delivery Pin</label>
                  <p>{consignmentDetails?.ISDELOTP || "---"}</p>
                </div>

                <div className=" consignor_code">
                  <label>Pickup Location</label>

                  <p>
                    {(consignmentDetails?.StartLocation || "---")
                      .split(",")
                      .map((part, i) => (
                        <span
                          key={i}
                          style={{
                            display: "block",
                            marginBottom: "6px",
                            lineHeight: "20px",
                          }}
                        >
                          {part.trim()}
                          {i <
                            consignmentDetails?.StartLocation.split(",")
                              .length -
                            1 && ","}
                        </span>
                      ))}
                  </p>
                </div>
                <div className="consignor_code">
                  <label>Pickup Date & Time</label>

                  <p>
                    {" "}
                    {moment(consignmentDetails?.PickUpDateTime)
                      .format("Do MMM YYYY; hh:mm A")
                      .split(",")
                      .map((part, i) => (
                        <span
                          key={i}
                          style={{
                            display: "block",
                            marginBottom: "6px",
                            lineHeight: "20px",
                          }}
                        >
                          {part.trim()}
                          {i <
                            consignmentDetails?.PickUpDateTime.split(",")
                              .length -
                            1 && ","}
                        </span>
                      )) || "---"}
                  </p>
                </div>
                <div className="consignor_code">
                  <label>Drop off Location</label>

                  <p>
                    {(consignmentDetails?.EndLocation || "---")
                      .split(",")
                      .map((part, i) => (
                        <span
                          key={i}
                          style={{
                            display: "block",
                            marginBottom: "6px",
                            lineHeight: "20px",
                          }}
                        >
                          {part.trim()}
                          {i <
                            consignmentDetails?.EndLocation.split("").length -
                            1 && ","}
                        </span>
                      ))}
                  </p>
                </div>
                <div className="consignor_code">
                  <label>Dropoff Date & Time</label>
                  <p>
                    {" "}
                    {moment(consignmentDetails?.DropOffDateTime)
                      .format("Do MMM YYYY; hh:mm A")
                      .split(",")
                      .map((part, i) => (
                        <span
                          key={i}
                          style={{
                            display: "block",
                            marginBottom: "6px",
                            lineHeight: "20px",
                          }}
                        >
                          {part.trim()}
                          {i <
                            consignmentDetails?.DropOffDateTime.split(",")
                              .length -
                            1 && ","}
                        </span>
                      )) || "---"}
                  </p>
                </div>

                <div className="  consignor_code">
                  <label>Pickup Notes</label>
                  <p>{consignmentDetails?.PickUpNote || "---"}</p>
                </div>
                <div className="consignor_code">
                  <label>Drop off Notes</label>
                  <p>{consignmentDetails?.DropOffNote || "---"}</p>
                </div>
                <div className="consignor_code">
                  <label>Remarks</label>
                  <p>{consignmentDetails?.Remarks || "---"}</p>
                </div>
                <div className="consignor_code">
                  <label>Trip</label>
                  <p>---</p>
                </div>

                <div className="consignor_code_container  consignor_code">
                  <label>Zone</label>
                  <p>{consignmentDetails?.TownName || "---"}</p>
                </div>
                {Array.isArray(CustomData) &&
                  CustomData.length > 0 &&
                  CustomData.map((field) => (
                    <div className="consignor_code" key={field.CFID}>
                      <label>{field.FIELDNAME}</label>
                      <p>{field.VALUE || "---"}</p>
                    </div>
                  ))}
              </div>
            </Col>
          )}
        </Row>
      </WrapperBox>

      {window.innerWidth >= 320 && window.innerWidth <= 426 ? (
        <WrapperBox>
          <Row>
            <Col xl={24} xs={24}>
              <Dropdown overlay={menu} trigger={["click"]}>
                <ButtonWhite
                  style={{
                    height: 30,
                    minWidth: 195,
                    minHeight: 0,
                    backgroundColor: "#d0f0c0", // light green
                    color: "#000",
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    marginBottom:
                      window.innerWidth >= 320 && window.innerWidth <= 374
                        ? "15px"
                        : "0px",
                    width:
                      window.innerWidth >= 320 && window.innerWidth <= 374
                        ? "190px"
                        : "auto",
                  }}
                >
                  <div className="containerfour">
                    {dropdownselectchange === "1" ? (
                      <>
                        <div>Event</div>{" "}
                      </>
                    ) : null || dropdownselectchange === "2" ? (
                      <>
                        <div>Files</div>
                      </>
                    ) : null || dropdownselectchange === "3" ? (
                      <>
                        <div>Comment</div>
                      </>
                    ) : null || dropdownselectchange === "4" ? (
                      <>
                        <div>Location</div>
                      </>
                    ) : null || dropdownselectchange === "5" ? (
                      <>
                        <div>KPIs </div>
                      </>
                    ) : null}

                    <div>
                      {dropdownselectchange === "1" ||
                        dropdownselectchange === "2" ||
                        dropdownselectchange === "3" ||
                        dropdownselectchange === "4" ||
                        dropdownselectchange === "5" ? (
                        <DownOutlined
                          style={{ width: "14px", height: "10px" }}
                        />
                      ) : (
                        <UpOutlined style={{ width: "14px", height: "10px" }} />
                      )}
                    </div>
                  </div>
                </ButtonWhite>
              </Dropdown>

              <div className="customizable_containerthree">
                {dropdownselectchange === "2" && (
                  <Upload
                    customRequest={({ file, onSuccess }) => {
                      // Get current position
                      navigator.geolocation.getCurrentPosition(
                        (position) => {
                          const { latitude, longitude } = position.coords;
                          const reader = new FileReader();
                          reader.readAsDataURL(file);

                          reader.onload = () => {
                            const base64Data = reader.result.split(",")[1];
                            onSuccess();

                            const payload = {
                              title: file.name,
                              fileSize: file.size,
                              mimeType: 1,
                              crBy: userInfo?.UID,
                              attKey: "testKey",
                              refTab: "CONSIGN",
                              refId: consignmentDetails?.ConsignId,
                              lat: String(latitude),
                              lng: String(longitude),
                              crOn: new Date(),
                              fileName: file.name,
                              fileType: file.name.split(".").pop(),
                              file: reader.result,
                            };
                            handleFileUpload(payload);
                          };

                          reader.onerror = (error) => {
                            console.error("File read error:", error);
                          };
                        },
                        (error) => {
                          // If location access denied or failed, fallback to empty values
                          console.error("Geolocation error:", error);
                          const reader = new FileReader();
                          reader.readAsDataURL(file);

                          reader.onload = () => {
                            onSuccess();
                            const payload = {
                              title: file.name,
                              fileSize: file.size,
                              mimeType: 1,
                              crBy: userInfo?.UID,
                              attKey: "testKey",
                              refTab: "CONSIGN",
                              refId: consignmentDetails?.ConsignId,
                              lat: "",
                              lng: "",
                              crOn: new Date(),
                              fileName: file.name,
                              fileType: file.name.split(".").pop(),
                              file: reader.result,
                            };
                            handleFileUpload(payload);
                          };
                        },
                      );
                    }}
                    showUploadList={false}
                  >
                    <Tooltip title={!fileUpAllowed ? "No permission" : ""}>
                      <ButtonFilled
                        style={{
                          cursor: fileUpAllowed ? "pointer" : "not-allowed",
                        }}
                        className="upload-style1"
                      >
                        + Add
                      </ButtonFilled>
                    </Tooltip>
                  </Upload>
                )}
                {dropdownselectchange === "1" && viewEvAllowed && (
                  <Spin spinning={loading}>
                    <StyledTable
                      dataSource={eventList}
                      pagination={false}
                      columns={columns1}
                      onRow={(record, index) => ({
                        onMouseEnter: () => {
                          handlemouseenter(record?.key);
                        },
                        onMouseLeave: () => {
                          handlemouseleave();
                        },
                      })}
                    />
                  </Spin>
                )}
                {dropdownselectchange === "2" && (
                  <Spin spinning={loading}>
                    <FilesTable
                      filesList={filesList}
                      getFileData={getFileData}
                    />
                  </Spin>
                )}
                {dropdownselectchange === "3" && (
                  <Spin spinning={loading}>
                    <ChatComponent
                      data={commentsList}
                      user={user}
                      getData={getCommentData}
                      id={consignmentDetails?.ConsignId}
                      RefTab="CONSIGN"
                      setLoading={setLoading}
                    />
                  </Spin>
                )}
                {dropdownselectchange === "4" && (
                  <Spin spinning={loading}>
                    <MapComponent
                      locationTab={eventlocationtab}
                      routePoints={startEndLoc}
                    />
                  </Spin>
                )}
                {dropdownselectchange === "5" && (
                  <Spin spinning={loading}>
                    <StyledTable
                      dataSource={Array.isArray(kpiList) ? kpiList : []}
                      pagination={false}
                      columns={columns5}
                      onRow={(record, index) => ({
                        onMouseEnter: () => {
                          handlemouseenter(record?.key);
                        },
                        onMouseLeave: () => {
                          handlemouseleave();
                        },
                      })}
                    />
                    <ReusablePagination
                      pageSize={pageSize}
                      handlePageSizeChange={handlePageSizeChange}
                      currentPage={currentPage}
                      total={total}
                      handlePageChange={handlePageChange}
                    />
                  </Spin>
                )}
              </div>
            </Col>
          </Row>
        </WrapperBox>
      ) : null}

      {window.innerWidth >= 320 && window.innerWidth <= 426 ? null : (
        <WrapperBox>
          <Row gutter={16}>
            <Col xl={24} xs={24}>
              <div
                style={{ marginTop: "12px" }}
                className="tabsectionfor_table"
              >
                <Tabs
                  className="consignor_tab_container"
                  onChange={handlechange}
                  type="card"
                  items={[
                    {
                      label: "Event",
                      key: "1",
                    },
                    {
                      label: "Files",
                      key: "2",
                    },
                    {
                      label: "Comment",
                      key: "3",
                    },
                    {
                      label: "Location",
                      key: "4",
                    },
                    {
                      label: "KPIs",
                      key: "5",
                    },
                  ]}
                />
                {activekey === "2" && (
                  <Upload
                    customRequest={({ file, onSuccess }) => {
                      // Get current position
                      navigator.geolocation.getCurrentPosition(
                        (position) => {
                          const { latitude, longitude } = position.coords;
                          const reader = new FileReader();
                          reader.readAsDataURL(file);

                          reader.onload = () => {
                            const base64Data = reader.result.split(",")[1];
                            onSuccess();

                            const payload = {
                              title: file.name,
                              fileSize: file.size,
                              mimeType: 1,
                              crBy: userInfo?.UID,
                              attKey: "testKey",
                              refTab: "CONSIGN",
                              refId: consignmentDetails?.ConsignId,
                              lat: String(latitude),
                              lng: String(longitude),
                              crOn: new Date(),
                              fileName: file.name,
                              fileType: file.name.split(".").pop(),
                              file: reader.result,
                            };
                            handleFileUpload(payload);
                          };

                          reader.onerror = (error) => {
                            console.error("File read error:", error);
                          };
                        },
                        (error) => {
                          // If location access denied or failed, fallback to empty values
                          console.error("Geolocation error:", error);
                          const reader = new FileReader();
                          reader.readAsDataURL(file);

                          reader.onload = () => {
                            onSuccess();
                            const payload = {
                              title: file.name,
                              fileSize: file.size,
                              mimeType: 1,
                              crBy: userInfo?.UID,
                              attKey: "testKey",
                              refTab: "CONSIGN",
                              refId: consignmentDetails?.ConsignId,
                              lat: "",
                              lng: "",
                              crOn: new Date(),
                              fileName: file.name,
                              fileType: file.name.split(".").pop(),
                              file: reader.result,
                            };
                            handleFileUpload(payload);
                          };
                        },
                      );
                    }}
                    showUploadList={false}
                  >
                    <ButtonFilled className="upload-style1">+ Add</ButtonFilled>
                  </Upload>
                )}
              </div>
            </Col>
          </Row>

          {activekey === "1" && (
            <Spin spinning={loading}>
              <StyledTable
                dataSource={eventList}
                pagination={false}
                columns={columns1}
                onRow={(record, index) => ({
                  onMouseEnter: () => {
                    handlemouseenter(record?.key);
                  },
                  onMouseLeave: () => {
                    handlemouseleave();
                  },
                })}
              />
            </Spin>
          )}
          {activekey === "2" && (
            <Spin spinning={loading}>
              <FilesTable filesList={filesList} getFileData={getFileData} />
            </Spin>
          )}
          {activekey === "3" && (
            <Spin spinning={loading}>
              <ChatComponent
                data={commentsList}
                user={user}
                getData={getCommentData}
                id={consignmentDetails?.ConsignId}
                RefTab="CONSIGN"
                setLoading={setLoading}
              />
            </Spin>
          )}
          {activekey === "4" && (
            <Spin spinning={loading}>
              <MapComponent
                locationTab={eventlocationtab}
                routePoints={startEndLoc}
              />
            </Spin>
          )}
          {activekey === "5" && (
            <Spin spinning={loading}>
              <StyledTable
                dataSource={Array.isArray(kpiList) ? kpiList : []}
                pagination={false}
                columns={columns5}
                onRow={(record, index) => ({
                  onMouseEnter: () => {
                    handlemouseenter(record?.key);
                  },
                  onMouseLeave: () => {
                    handlemouseleave();
                  },
                })}
              />
              <ReusablePagination
                pageSize={pageSize}
                handlePageSizeChange={handlePageSizeChange}
                currentPage={currentPage}
                total={total}
                handlePageChange={handlePageChange}
              />
            </Spin>
          )}
        </WrapperBox>
      )}

      <UIModal
        customHeight={500}
        open={isMapModalOpen}
        onClose={handleClosecontainer}
        closeButton={false}
      >
        <MapComponent
          locationsTL={
            selectedRecord && selectedRecord.Lat && selectedRecord.Lng
              ? [
                {
                  ...selectedRecord,
                  Lat: Number(selectedRecord.Lat),
                  Lng: Number(selectedRecord.Lng),
                },
              ]
              : []
          }
          pinlocation={
            selectedRecord && selectedRecord.Lat && selectedRecord.Lng
              ? [
                {
                  lat: Number(selectedRecord.Lat),
                  lng: Number(selectedRecord.Lng),
                },
              ]
              : []
          }
          isminimap={true}
        />
        {/* <MapComponent
  locationsTL={
    selectedRecord && selectedRecord.Lat && selectedRecord.Lng
      ? [{
          ...selectedRecord,
          Lat: Number(selectedRecord.Lat),
          Lng: Number(selectedRecord.Lng),
          locationName: selectedRecord.locationName 
        }]
      : []
  }
  pinlocation={
    selectedRecord && selectedRecord.Lat && selectedRecord.Lng
      ? [{ lat: Number(selectedRecord.Lat), lng: Number(selectedRecord.Lng) }]
      : []
  }

  isminimap={true}
/> */}
      </UIModal>
      <Modal
        title={`Update Event - ${EventType.find((item) => item.value === eventData?.EVTYPE)?.name || ""
          }`}
        visible={isModalOpeN}
        onCancel={() => {
          setIsModalOpeN(false);
          form.resetFields();
          setEventData({});
        }}
        footer={[
          <Buttontransparent
            key="cancel"
            onClick={() => {
              setIsModalOpeN(false);
              form.resetFields();
              setEventData({});
            }}
            style={{ background: "#E6F4EA", color: "#1677FF" }}
          >
            Cancel
          </Buttontransparent>,
          <ButtonFilled
            key="submit"
            type="primary"
            onClick={() => form.submit()}
            style={{ background: "#008000" }}
            loading={loading}
          >
            Update
          </ButtonFilled>,
        ]}
      >
        <Form
          form={form}
          layout="vertical"
          onFinish={updateevents}
          initialValues={eventData}
        >
          <Row gutter={16}>
            {getFieldsForEvent(eventData?.EVTYPE)?.includes("odo") && (
              <Col sm={24} md={12}>
                <Form.Item
                  name="odo"
                  label="ODO Reading"
                  rules={[
                    { required: true, message: "Please enter ODO Reading" },
                  ]}
                >
                  <Input type="text" />
                </Form.Item>
              </Col>
            )}

            {getFieldsForEvent(eventData?.EVTYPE)?.includes("datetime") && (
              <Col sm={24} md={12}>
                <Form.Item
                  name="datetime"
                  label="Date & Time"
                  //initialValue={moment()}
                  rules={[{ required: true, message: "Please select a Date" }]}
                >
                  <DatePicker
                    showTime={{ format: "HH:mm" }}
                    format="YYYY-MM-DD HH:mm"
                    style={{ width: "100%" }}
                  />
                </Form.Item>
              </Col>
            )}

            {getFieldsForEvent(eventData?.EVTYPE)?.includes("location") && (
              <Col sm={24} md={12}>
                <Form.Item
                  name="location"
                  label="Location"
                  rules={[
                    { required: true, message: "Please select the location" },
                  ]}
                >
                  <Input
                    readOnly
                    placeholder="Select a location"
                    value={form.getFieldValue("location") || ""}
                    onClick={() => {
                      form.setFieldsValue({ location: "" }); // Clear previous value
                      setIsLocationPickerVisible(true);
                    }}
                  />
                </Form.Item>
              </Col>
            )}
            {getFieldsForEvent(eventData?.EVTYPE)?.includes("remarks") && (
              <Col sm={24} md={24}>
                <Form.Item
                  name="remarks"
                  label="Remarks"
                  rules={[{ required: false }]}
                >
                  <Input placeholder="Enter remarks" />
                </Form.Item>
              </Col>
            )}
          </Row>
        </Form>
      </Modal>
      <Modal
        title={
          <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
            <Alert />
            <span>Information</span>
          </div>
        }
        visible={isPopupVisible}
        onOk={() => setIsPopupVisible(false)} // Close the popup when "OK" is clicked
        onCancel={() => setIsPopupVisible(false)} // Allow closing with the "X" button
        footer={[
          <ButtonFilled key="ok" onClick={() => setIsPopupVisible(false)}>
            OK
          </ButtonFilled>,
        ]}
      >
        <p>{popupMessage}</p>
      </Modal>
      <LocationPicker
        visible={isLocationPickerVisible}
        onClose={() => setIsLocationPickerVisible(false)} // Close the modal
        onSelect={handleLocationSelect} // Handle the selected location
      />
      <UIModal
        width={700}
        open={isConformationModal}
        onClose={() => {
          setIsConformationModal(false);
          setCopyId(null);
        }}
        closeButton={false}
        size="md"
        header={false}
        footer={false}
      >
        <div className="text-center">
          <h1>Are you sure,</h1>
          <h6>You want to duplicate this consignment?</h6>
          <div className="mt-2 w-100 d-flex justify-content-center">
            <ButtonFilled loading={newLoading} onClick={handleCopyClick}>
              Yes
            </ButtonFilled>
            <Buttontransparent
              onClick={() => {
                setIsConformationModal(false);
                setCopyId(null);
              }}
            >
              No
            </Buttontransparent>
          </div>
        </div>
      </UIModal>
      <UIModal
        width={500}
        open={isDeleteModalVisible}
        onClose={() => {
          setIsDeleteModalVisible(false);
          setDeleteId(null); // Reset the delete ID
        }}
        closeButton={false}
        size="md"
        header={false}
        footer={false}
      >
        <div className="text-center">
          <h1>Are you sure,</h1>
          <h6>You want to delete this consignment?</h6>
          <div className="mt-2 w-100 d-flex justify-content-center">
            <ButtonFilled
              onClick={() => {
                handleDelete(deleteId); // Call the delete function with the selected ID
                setIsDeleteModalVisible(false); // Close the modal
                setDeleteId(null); // Reset the delete ID
              }}
            >
              Yes
            </ButtonFilled>
            <Buttontransparent
              onClick={() => {
                setIsDeleteModalVisible(false); // Close the modal
                setDeleteId(null); // Reset the delete ID
              }}
            >
              No
            </Buttontransparent>
          </div>
        </div>
      </UIModal>

      <ReusableDrawer
        title=""
        open={drawyeropen}
        setOpen={setDrawyeropen}
        onClose={handleClose}
        closable={false}
        footer={[
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              justifyContent: "flex-end",
              gap: "15px",
            }}
          >
            <Button
              key="cancel"
              className="cancel-btn"
              onClick={handleClose}
              style={{
                borderRadius: "26px",
                backgroundColor: "#E8FFEC",
                color: "#2C963D",
                borderColor: "#E8FFEC",
                width: "118px",
                height: "38px",
              }}
            >
              Cancel
            </Button>
            <ButtonFilled
              key="create"
              type="primary"
              onClick={handleSubmitForm}
            >
              Create
            </ButtonFilled>
          </div>,
        ]}
      >
        <WrapperBox>
          <Row gutter={16}>
            <Col xl={24} xs={24}>
              <div className="Creating_Consignor">
                <p>Creating Consignor</p>

                <span>
                  <CloseOutlined onClick={handleClose} />
                </span>
              </div>
            </Col>
          </Row>
          <Row gutter={16}>
            <Col xl={24} xs={24}>
              <GridBuilder
                formStructureJson={AddEditFormm}
                handleChange={handleChange}
                formSubmit={handleSubmitForm}
                initialValues={formData}
                form={form}
              />
            </Col>
          </Row>
        </WrapperBox>
      </ReusableDrawer>
    </>
  );
};

export default ConsignCode;
